import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { getSiteName, useContent } from "../lib/content";
import { toast } from "sonner";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { content } = useContent();
  const siteName = getSiteName(content);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password });
      localStorage.setItem("archdigital_admin_token", res.data.token);
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error("Incorrect password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(200,96,44,0.12),transparent_60%)]"
      />
      <div className="relative w-full max-w-md px-6">
        <Link
          to="/"
          className="font-mono text-[11px] uppercase tracking-[0.3em] text-bone-200/60 hover:text-ember transition-colors mb-12 inline-block"
        >
          ← {siteName}
        </Link>

        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-bone-200/50 mb-4">
          ⸺ Restricted Access
        </div>
        <h1 className="font-display text-5xl tracking-tightest leading-[0.95] mb-10">
          Studio <span className="italic text-bone-200/60">console</span>
        </h1>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label
              htmlFor="password"
              className="block font-mono text-[10px] uppercase tracking-[0.3em] text-bone-200/50 mb-3"
            >
              Admin Passphrase
            </label>
            <input
              id="password"
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-bone-50/20 py-3 font-mono tracking-wider focus:outline-none focus:border-ember transition-colors"
              placeholder="••••••••"
              autoFocus
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full group font-mono text-xs uppercase tracking-[0.3em] border border-bone-50/20 py-4 hover:border-ember hover:text-ember transition-colors disabled:opacity-50"
          >
            {loading ? "Authenticating…" : "Enter Studio →"}
          </button>
        </form>
      </div>
    </main>
  );
}
